import { format } from "date-fns";
// import { utcToZonedTime } from "date-fns-tz";
import { toZonedTime } from "date-fns-tz";

export function getNameInitials(firstName, lastName) {
  return (firstName ? firstName[0] : "") + (lastName ? lastName[0] : "");
}

export function extractNumbers(input, maxLength) {
  const str = maxLength != null ? input.slice(0, maxLength) : input;
  const matches = str.match(/\d/g);

  if (matches?.length) {
    return matches.join("");
  }

  return "";
}

export function getDateObj(date) {
  //   if (isNaN(date)) {
  //     return;
  //   }
  try {
    return {
      name: format(date, "MMM, yy"),
      value: `${date.getFullYear() * 100 + (date.getMonth() + 1)}`,
    };
  } catch (err) {
    // console.log(err);
    return;
  }
}

export function formatUTCToIST(time) {
  const date = new Date(time);

  const ISTTime = toZonedTime(date, "Asia/Kolkata");
  if (isNaN(ISTTime)) {
    // console.error("Invalid Date object");
    return;
  }
  const formattedDate = format(
    ISTTime,
    "EEE MMM dd yyyy HH:mm:ss 'GMT'XXX '(India Standard Time)'"
  );

  return formattedDate;
}
